import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { terms } from "src/app/util/constants";

@Component({
  selector: "app-payment-index",
  templateUrl: "./payment-index.component.html",
})
export class PaymentIndexComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) { }

  downloader: any = null;

  payload: any = {};
  notification = {};

  fakeLoader = false;
  loading = false;
  dialog = false;
  dialogVisible = false;
  sessions: string[] = [];
  selectedTerm = "";
  selectedSession = "";
  terms: any[] = terms;
  popupContext: string = "";
  _checks = authData("_checks");

  links: any[] = [
    {
      title: `Make Payment`,
      slug: `/payments/tranzgate`,
      icon: `/assets/icons/credit-card.png`,
      text: "Add a line or two here that explains what this card does",
    }
    // {
    //   title: "Generate Fees",
    //   slug: "/payments/generate",
    //   icon: "/assets/icons/papers.svg",
    //   text: "Add a line or two here that explains what this card does",
    // },
    // {
    //   title: "View Pay Advice",
    //   slug: "/payments/advice",
    //   icon: "/assets/icons/receipt.png",
    //   text: "Add a line or two here that explains what this card does",
    // },
  ];

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    this.fetchSessions();
    const remita = this._checks.UseRemita;
    if (remita) {
      this.links.push(
        {
          title: `Pay With Remita`,
          slug: `/payments/remita`,
          icon: `/assets/icons/remita.svg`,
          text: "Add a line or two here that explains what this card does",
        }
      );

    }

    const message: string = location.hash.slice(1);
    if (message) {
      this.notification = {
        message: message.replace(/\+/g, " "),
      };
    } else {
      const baseUrl = `${environment.BASE_URL}/payments/refereshStatus`;
      this.httpClient.get(baseUrl, this.httpOptions);
    }
  }

  submitPrintReciepts(): void {
    this.printReciepts(this.selectedSession, this.selectedTerm);
  }

  printReciepts(session: string, term: string): void {
    if (this.loading) return;

    const _checks = authData("_checks");
    const { StudentHasFilledBioData } = _checks;
    if (!StudentHasFilledBioData) {
      this.notification = {
        message: "You haven't filled your bio-data form",
        error: true,
      };
      return;
    }

    this.loading = true;
    this.downloader = {
      loading: true,
    };
    const baseUrl = `${environment.BASE_URL}/payments/reciept?session=${session}&term=${term || 0}`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.downloader = {
            loading: false,
            name: res.Data.Name,
            url: `data:application/octet-stream;base64,${res.Data.Data}`,
          };
        } else {
          this.downloader = null;
          this.notification = { error: true, message: res.Message };
        }
      },
      error: (err) => {
        this.downloader = null;
        this.notification = errorHandler(err);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  fetchSessions(): void {
    const baseUrl = `${environment.BASE_URL}/payments/sessionList`;
    this.loading = true;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.sessions = res.Data || [];
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.notification = errorHandler(err);
      }
    );
  }

  refreshPayment(): void {
    if (this.loading) return;

    this.dialog = true;
    this.notification = {};
    this.loading = true;

    const baseUrl = `${environment.BASE_URL}/payments/refereshStatus`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        this.payload = res.Data;
        this.notification = {
          error: false,
          message: "Payment refreshed successfully",
        };
      },
      error: (err) => {
        this.notification = errorHandler(err);
      },
      complete: () => {
        this.loading = false;
        this.dialog = false;
      },
    });
  }
  openPopup(context: string): void {
    this.popupContext = context;
    this.dialogVisible = true;
  }
  closeDialog(): void {
    this.dialogVisible = false;
    this.selectedSession = "";
    this.selectedTerm = "";
  }

  submitPopup(): void {
    if (this.popupContext === "payAdvice") {
      this.submitPayAdvice();
    } else if (this.popupContext === "printReceipt") {
      this.submitPrintReciepts();
    }
    this.closeDialog()
  }

  submitPayAdvice(): void {
    this.generateAdvice(this.selectedSession, this.selectedTerm);
  }

  generateAdvice(session: string, term: string): void {
    if (this.loading) return;

    this.loading = true;
    this.notification = {};

    this.downloader = {
      loading: true,
    };
    const baseUrl = `${environment.BASE_URL}/payments/ViewPaymentAdvice?session=${session}&term=${term || 0}`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          if (!res.Data.RemitaOnlinePayment) {
            this.downloader = {
              loading: false,
              name: res.Data.FileAttachments.Name,
              url: `data:application/octet-stream;base64,${res.Data.FileAttachments.Data}`,
            };
            this.dialog = false;
          } else {
            this.downloader = null;
            if (environment.remita)
              this.router.navigateByUrl(`/payments/remita`);
            else this.router.navigateByUrl(`/payments/tranzgate`);
          }
        } else {
          this.downloader = null;
          this.notification = { error: true, message: res.Message };
        }
      },
      error: (err) => {
        this.downloader = null;
        this.notification = errorHandler(err);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
        this.closeDialog();
      },
    });
  }
}
